import { Head, CleanContent } from './ui';
import { benefits } from '../data';

export default function Benefits() {
  return (
    <CleanContent><section className="py-5">
        <div className="container">
          <Head eyebrow="Commercial Advantage" title="The Institutional Benefits"
            text="Holding a verified SELECTEZI Star Rank delivers tangible competitive leverage across all stages of enterprise procurement" />
          <div className="row g-3 justify-content-center">
            {benefits.map(([ic, t, d]) => (
              <div className="col-md-6 col-lg-4" key={t}>
                <div className="border border-line rounded-3 p-3 h-100">
                  <div className="icon-box rounded-2 d-flex align-items-center justify-content-center mb-2"><i className={`bi ${ic}`} /></div>
                  <div className="h-md mb-1">{t}</div><p className="p-sm mb-0">{d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section></CleanContent>
  );
}
